import React from 'react';
import ConfirmationModal from '../../../common/ConfirmationModal';

export type DeleteItemType = 'survey' | 'draft' | 'template';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  itemType: DeleteItemType;
  itemTitle?: string;
}

const getItemTypeLabel = (type: DeleteItemType): string => {
  switch (type) {
    case 'survey': return 'published survey';
    case 'draft': return 'draft';
    case 'template': return 'template';
    default: return 'item';
  }
};

/** Delete confirmation — shared ConfirmationModal shell, same contract. */
const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  loading = false,
  itemType,
  itemTitle,
}) => {
  const itemLabel = getItemTypeLabel(itemType);

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={`Delete ${itemType === 'survey' ? 'Survey' : 'Item'}`}
      message={`Are you sure you want to delete this ${itemLabel}${itemTitle ? ` "${itemTitle}"` : ''}? This action cannot be undone.`}
      isLoading={loading}
      type="danger"
    />
  );
};

export default DeleteConfirmModal;
